import { z } from 'zod';

// Audit kinds match prototype/src/data.jsx AUDIT_LOG.kind values plus the
// categories implied by the brief (CMS edits, role changes, KYC, doc downloads).
export const AUDIT_KINDS = [
  'submit',     // client submitted a brief
  'proposal',   // proposal sent / accepted / declined
  'kyc',        // KYC reviewed / approved / refresh requested
  'user',       // user invited / role changed / deactivated
  'finance',    // invoice issued / marked paid / refunded
  'doc',        // document uploaded / downloaded / dual-sign-off
  'system',     // policy version bump, material legal change, feature flag flipped
  'auth',       // sign-in / sign-out / failed code / re-acceptance
  'cms',        // CMS edit (page, service, legal, banner, flag, media)
  'engagement', // state change submitted→reviewing→engagement→delivered
  'message',    // message sent (internal flag tracked separately)
  'client',     // client created / updated / status changed (REQ-007)
] as const;
export const AuditKindSchema = z.enum(AUDIT_KINDS);
export type AuditKind = z.infer<typeof AuditKindSchema>;

export const AuditEntrySchema = z.object({
  id: z.string(),
  kind: AuditKindSchema,

  actor_id: z.string().nullable(),
  actor_name: z.string(),
  actor_kind: z.enum(['staff', 'client', 'system']),

  what: z.string().min(1),

  resource: z.string().optional(),
  resource_id: z.string().optional(),
  diff: z.record(z.unknown()).optional(),

  ip: z.string().optional(),
  user_agent: z.string().optional(),

  at: z.date(),
});
export type AuditEntry = z.infer<typeof AuditEntrySchema>;

// Query filters for GET /audit (admin only)
export const AuditQuerySchema = z.object({
  kind: AuditKindSchema.optional(),
  actor_id: z.string().optional(),
  resource: z.string().optional(),
  resource_id: z.string().optional(),
  from: z.coerce.date().optional(),
  to: z.coerce.date().optional(),
  limit: z.coerce.number().int().min(1).max(500).default(100),
  cursor: z.string().optional(),
});
export type AuditQuery = z.infer<typeof AuditQuerySchema>;
